import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

import { ButtonsAngularModule } from 'rev-shared/ui/buttons/ButtonsAngular.Module';
import { FormDirectivesAngularModule } from 'rev-shared/util/directives/form/FormDirectivesAngular.Module';
import { FormGroupAngularModule } from 'rev-shared/ui/formGroup/FormGroupAngular.Module';
import { SpinnerAngularModule } from 'rev-shared/ui/spinner/SpinnerAngular.Module';
import { ValidationModule } from 'rev-shared/util/directives/form/validation/Validation.AngularModule';
import { VbTextAreaModule } from 'rev-shared/ui/textArea/VbTextArea.Module';
import { WebexTeamsModule } from 'rev-portal/scheduledEvents/webex-teams/WebexTeams.Module';
import { ZoomAngularModule } from 'rev-portal/scheduledEvents/zoom/ZoomAngularModule';

import { CollapseModule } from 'ngx-bootstrap/collapse';
import { DateAngularModule } from 'rev-shared/date/DateAngular.Module';
import { DirectivesAngularModule } from 'rev-shared/util/directives/DirectivesAngular.Module';
import { RecordingProcessComponent } from './RecordingProcess.Component';
import { StatusSpinnersAngularModule } from 'rev-shared/statusSpinners/StatusSpinnersAngular.Module';
import { ValidationAngularModule } from 'rev-shared/ui/validation/ValidationAngular.Module';
import { VbUiTooltipModule } from 'rev-shared/ui/tooltip/VbUiTooltip.Module';

import { RecordingMenuComponent } from './RecordingMenu.Component';
import { RecordingTimerComponent } from './RecordingTimer.Component';

const components = [
	RecordingMenuComponent,
	RecordingTimerComponent,
	RecordingProcessComponent,
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		ButtonsAngularModule,
		CommonModule,
		CollapseModule,
		DateAngularModule,
		DirectivesAngularModule,
		FormDirectivesAngularModule,
		FormGroupAngularModule,
		FormsModule,
		ReactiveFormsModule,
		SpinnerAngularModule,
		StatusSpinnersAngularModule,
		TranslateModule,
		TypeaheadModule,
		ValidationAngularModule,
		ValidationModule,
		VbTextAreaModule,
		VbUiTooltipModule,
		WebexTeamsModule,
		ZoomAngularModule
	]
})
export class RecordingAngularModule {}
